export default __webpack_public_path__ + "static/media/black_left_arrow.b6db5033.svg";